export const StageOnwerSettingCode = {
    leadOwnerSttingCode: 'StageOwnerSetting',
    accountOwnerSttingCode: 'StageOwnerSetting',
    opportunityOwnerSttingCode: 'StageOwnerSetting',
    casesOwnerSttingCode: 'StageOwnerSetting',
}